<template>
  <v-app style="background-color:white">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <v-card class="form-container" flat style="margin-top:-10px">
        <v-layout row wrap>
            <v-flex xs12 sm12 md8>
                <v-text-field v-model="customerCode" label="Enter a Customer Code"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-btn :loading="searchBtn" color="#e53935" dark depressed block large @click="searchData()">Seach Customer</v-btn>
            </v-flex>
        </v-layout>
    </v-card>
    <v-card class="form-container" flat style="margin-top:-50px;border:1px solid" v-if="show==true">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
            <v-flex xs12 sm12 md4 style="padding-right:5px">
                <v-text-field disabled v-model="customer.FullName" label="Customer Name"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4 style="padding-right:5px">
                <v-text-field disabled v-model="customer.MobileNumber" label="Mobile No"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4 style="padding-right:5px">
                <v-text-field disabled v-model="customer.Email" label="Email ID"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-dialog
                ref="dialog"
                v-model="dateModel"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  append-icon="event"
                  slot="activator"
                  v-model="form.invoiceDate"
                  label="Invoice date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="form.invoiceDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="dateModel = false">ok</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>

            <v-flex xs12>
            <v-toolbar flat color="transparent">
              <v-toolbar-title class="grey--text">Item selection</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <!-- Here is a dialog i'm activating when ADD NEW button will click -->
              <v-dialog v-model="dialog" max-width="500px">
                <v-btn color="primary" depressed slot="activator">Add new</v-btn>
                <v-card style="border-radius: 10px">
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-autocomplete
                            v-model="selectedItem"
                            :items="items"
                            label="Select item"
                            item-text="ItemName"
                            item-value="ProductId"
                            @change="getBatchList()"
                          ></v-autocomplete>
                          <v-autocomplete
                            v-if="batches.length>0"
                            v-model="selectedBatch"
                            :items="batches"
                            label="Select Batch"
                            item-text="BatchNumber"
                            item-value="Id"
                            @change="getItemDetail()"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <div class="text-xs-center" v-if="isLoading">
                        <v-progress-circular indeterminate color="amber"></v-progress-circular>
                      </div>
                      <v-layout row wrap v-if="show1==true">
                        <v-flex sm4 md4 xs12>
                          <v-text-field disabled label="HSN code" v-model="itemDetails.Code"></v-text-field>
                        </v-flex>
                        <v-flex sm4 md4 xs12>
                          <v-text-field disabled label="HSN rate" v-model="itemDetails.HsnRate"></v-text-field>
                        </v-flex>
                        <v-flex sm4 md4 xs12>
                          <v-text-field disabled label="DP" v-model="itemDetails.Mrp"></v-text-field>
                        </v-flex>
                        <v-flex sm4 md4 xs12>
                          <v-text-field disabled label="Avl qty" v-model="itemDetails.Quantity"></v-text-field>
                        </v-flex>
                        <v-flex sm4 md4 xs12>
                          <v-text-field label="Qty" v-model="editedItem.qty" @change="currectQty()"></v-text-field>
                        </v-flex>
                        <v-flex sm4 md4 xs12>
                          <v-text-field disabled label="Unit" v-model="itemDetails.UomName"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <div style="font-family: roboto mono;font-size:12px" v-if="show1==true">
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md6>
                            <p>TOTAL : {{ (itemDetails.Mrp * editedItem.qty).toFixed(2) }}</p>
                            <p>TAXABLE VALUE : {{ ((itemDetails.Mrp * editedItem.qty) - ((itemDetails.Mrp * editedItem.qty) * (itemDetails.Discount) / 100)).toFixed(2) }}</p>
                           </v-flex>
                          <v-flex xs12 sm12 md6>
                            <p>DISCOUNT : {{ ((itemDetails.Mrp * editedItem.qty) * (itemDetails.Discount) / 100).toFixed(2) }}&nbsp;({{itemDetails.Discount}}%)</p>
                          </v-flex>
                          <v-flex xs12 sm12 md4>
                            <span v-if="companyStateCode === customer.StateCode">
                          <p>CGST : {{ ((((itemDetails.Mrp * editedItem.qty) - ((itemDetails.Mrp * editedItem.qty) * (itemDetails.Discount) / 100)) * ((itemDetails.HsnRate) / 100)) / 2).toFixed(2) }}</p>
                        </span>
                        <span v-if="companyStateCode != customer.StateCode">
                          <p>CGST : 0</p>
                        </span>
                          </v-flex>

                          <v-flex xs12 sm12 md4>
                        <span v-if="companyStateCode === customer.StateCode">
                          <p>SGST : {{ ((((itemDetails.Mrp * editedItem.qty) - ((itemDetails.Mrp * editedItem.qty) * (itemDetails.Discount) / 100)) * ((itemDetails.HsnRate) / 100)) / 2).toFixed(2) }}</p>
                        </span>
                        <span v-if="companyStateCode != customer.StateCode">
                          <p>SGST : 0</p>
                        </span>
                          </v-flex>

                          <v-flex xs12 sm12 md4>
                        <span v-if="companyStateCode != customer.StateCode">
                          <p>IGST : {{ (((itemDetails.Mrp * editedItem.qty) - ((itemDetails.Mrp * editedItem.qty) * (itemDetails.Discount) / 100)) * ((itemDetails.HsnRate) / 100)).toFixed(2) }}</p>
                        </span>
                        <span v-if="companyStateCode === customer.StateCode">
                          <p>IGST : 0</p>
                        </span>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click="close()">Cancel</v-btn>
                    <v-btn color="success" flat @click="save()">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>

            <v-data-table
              :headers="headers"
              :items="itemAdded"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.item }}</td>
                <td class="text-xs-left">{{ props.item.qty }}</td>
                <td class="text-xs-left">{{ props.item.hSNCode }}</td>
                <td class="text-xs-left">{{ props.item.batchNumber }}</td>
                <td class="text-xs-left">{{ props.item.unit }}</td>
                <td class="text-xs-left">{{ props.item.mrp }}</td>
                <td class="text-xs-left">{{ props.item.total }}</td>
                <td class="text-xs-left">{{ props.item.discountAmount }}</td>
                <td class="text-xs-left">{{ props.item.taxableAmount }}</td>
                <td class="text-xs-left">{{ props.item.cgst }}</td>
                <td class="text-xs-left">{{ props.item.sgst }}</td>
                <td class="text-xs-left">{{ props.item.igst }}</td>

                <td class="justify-center layout px-0">
                  <v-icon color="error" small @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>
            <!-- TOTAL ALL -->
            <v-flex xs12 v-if="itemAdded" class="mt-4">
              <v-toolbar flat color="transparent">
                <v-toolbar-title class="info--text">Total calculation</v-toolbar-title>
              </v-toolbar>
              <div class="ml-1" style="font-family: roboto mono">
                <v-chip label color="blue-grey " text-color="white">
                  <v-icon left>assessment</v-icon>
                  Taxable amount: {{Math.round(taxableAmount * 100) / 100}}
                </v-chip>
                <br>
                <v-chip label color="blue-grey " text-color="white">
                  <v-icon left>description</v-icon>
                  CGST: {{cgstTotal.toFixed(2)}}
                </v-chip>
                <v-chip label color="blue-grey " text-color="white">
                  <v-icon left>description</v-icon>
                  SGST: {{sgstTotal.toFixed(2)}}
                </v-chip>
                <v-chip label color="blue-grey " text-color="white">
                  <v-icon left>description</v-icon>
                  IGST: {{igstTotal.toFixed(2)}}
                </v-chip>
                <v-chip label color="blue-grey " text-color="white">
                  <v-icon left>description</v-icon>
                  GST: {{(cgstTotal + sgstTotal + igstTotal).toFixed(2)}}
                </v-chip>
                <br>
                <v-chip label color="blue-grey darken-3" text-color="white">
                  <v-icon left>swap_vertical_circle</v-icon>
                  Total amount after tax: {{Math.round((taxableAmount + cgstTotal + sgstTotal + igstTotal) * 100) / 100}}
                </v-chip>
              </div>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
            <v-btn depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
          </v-flex>
          
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create Counselling",
      entries: [],
      dialog: false,
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      show: false,
      show1: false,
      searchBtn: false,
      dateModel: false,
      companyStateCode: null,

      customerCode: null,
      customer: {},

      itemDetails: {},

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Invoice",
          disabled: false,
          to: "/invoice"
        },
        {
          text: "Create",
          disabled: true,
          to: "/createStudent"
        }
      ],
      form: {
          invoiceDate: new Date().toISOString().substr(0, 10)
      },
      editedItem: {
        qty: 1
      },
      headers: [
        { text: "Select item", value: "item" },
        { text: "Qty.", value: "targetQty" },
        { text: "HSN code", value: "hSNCode" },
        { text: "Batch", value: "batchNumber" },
        { text: "Unit", value: "unit" },
        { text: "MRP", value: "mrp" },
        { text: "Total", value: "total" },
        { text: "Discount", value: "discount" },
        { text: "Taxable value", value: "taxableAmount" },
        { text: "CGST", value: "cgst" },
        { text: "SGST", value: "sgst" },
        { text: "IGST", value: "igst" },
        { text: "Remove", value: "Remove" }
      ],

      items: [],
      selectedItem: 0,

      selectedBatch: 0,
      batches: [],

      itemAdded: []
    };
  },

  mounted() {
      this.axios
        .get(config.API + "ItemList", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.items = res.data;
          this.$Progress.finish();
        });

      // Companies
      this.axios
      .get(config.API + "Companies", { headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              } })
      .then(response => {
        this.companyStateCode = response.data[0].billingStateCode;
        this.$Progress.finish();
      });
    },

  methods: {
      getItemDetail() {
        this.isLoading = true;
        this.axios
          .post(
            config.API + `ItemDetail`,
            {
              inventoryId: JSON.parse(this.selectedBatch)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.itemDetails = res.data[0];
            this.isLoading = false;
            this.show1 = true;
          });
      },
      getBatchList() {
        this.seatchBtn = true;
        this.axios
          .post(
            config.API + `BatchList`,
            {
              productId: JSON.parse(this.selectedItem)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.batches = res.data;
          });
      },
      searchData() {
          if (this.customerCode != null) {
        this.searchBtn = true;
        this.axios
          .post(
            config.API + `SearchCustomer`,
            {
              customerCode: this.customerCode
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.customer = res.data[0];
            this.show = true;
            this.searchBtn = false;
          })
          .catch(err => {
            this.$toaster.error('Please enter a Customer Code');
            this.searchBtn = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
      },
    back() {
      this.$router.go(-1);
    },
    save() {

      let lth = this.itemAdded.length;
      if (lth == 0) {
        if (this.editedItem.qty <= this.itemDetails.Quantity) {
        // CHECH IF CGST OR SGST
       if (this.companyStateCode === this.customer.StateCode) {
        // CGST & SGST
        this.itemAdded.push({
          item: this.itemDetails.ItemName,
          productId: JSON.parse(this.selectedItem),
          hSNCode: this.itemDetails.Code,
          hSNRate: JSON.parse(this.itemDetails.HsnRate),
          qty: JSON.parse(this.editedItem.qty),
          unit: this.itemDetails.UomName,
          mrp: this.itemDetails.Mrp,
          batchNumber: this.itemDetails.BatchNumber,
          total: JSON.parse(
            (this.itemDetails.Mrp * this.editedItem.qty).toFixed(2)
          ),
          discount: JSON.parse(this.itemDetails.Discount),
          discountAmount: JSON.parse(
            (
              (this.itemDetails.Mrp *
                this.editedItem.qty *
                this.itemDetails.Discount) /
              100
            ).toFixed(2)
          ),
          taxableAmount: JSON.parse(
            (
              this.itemDetails.Mrp * this.editedItem.qty -
              (this.itemDetails.Mrp *
                this.editedItem.qty *
                this.itemDetails.Discount) /
                100
            ).toFixed(2)
          ),
          cgst: JSON.parse(
            (
              ((this.itemDetails.Mrp * this.editedItem.qty -
                (this.itemDetails.Mrp *
                  this.editedItem.qty *
                  this.itemDetails.Discount) /
                  100) *
                (this.itemDetails.HsnRate / 100)) /
              2
            ).toFixed(2)
          ),
          cgstRate: JSON.parse(this.itemDetails.HsnRate / 2),
          sgst: JSON.parse(
            (
              ((this.itemDetails.Mrp * this.editedItem.qty -
                (this.itemDetails.Mrp *
                  this.editedItem.qty *
                  this.itemDetails.Discount) /
                  100) *
                (this.itemDetails.HsnRate / 100)) /
              2
            ).toFixed(2)
          ),
          sgstRate: JSON.parse(this.itemDetails.HsnRate / 2),
          igstRate: 0,
          igst: 0
        });
      } else {
        // IGST
        this.itemAdded.push({
          item: this.itemDetails.ItemName,
          productId: JSON.parse(this.selectedItem),
          hSNCode: this.itemDetails.Code,
          hSNRate: JSON.parse(this.itemDetails.HsnRate),
          qty: JSON.parse(this.editedItem.qty),
          unit: this.itemDetails.UomName,
          batchNumber: this.itemDetails.BatchNumber,
          mrp: this.itemDetails.Mrp,
          total: JSON.parse(
            (this.itemDetails.Mrp * this.editedItem.qty).toFixed(2)
          ),
          discount: JSON.parse(this.itemDetails.Discount),
          discountAmount: JSON.parse(
            (
              (this.itemDetails.Mrp *
                this.editedItem.qty *
                this.itemDetails.Discount) /
              100
            ).toFixed(2)
          ),
          taxableAmount: JSON.parse(
            (
              this.itemDetails.Mrp * this.editedItem.qty -
              (this.itemDetails.Mrp *
                this.editedItem.qty *
                this.itemDetails.Discount) /
                100
            ).toFixed(2)
          ),
          cgst: 0,
          cgstRate: 0,
          sgst: 0,
          sgstRate: 0,
          igstRate: JSON.parse(this.itemDetails.HsnRate),
          igst: JSON.parse(
            (
              (this.itemDetails.Mrp * this.editedItem.qty -
                (this.itemDetails.Mrp *
                  this.editedItem.qty *
                  this.itemDetails.Discount) /
                  100) *
              (this.itemDetails.HsnRate / 100)
            ).toFixed(2)
          )
        });
      }

       this.close();
      }
      else {
        this.$toaster.error(`Qty should be less then or equal Avl qty`);
        this.editedItem.qty = null;
      }
      }
      else {
        let flag = '';

        for(let i = 0; i < lth; i++) {
          let item_id = this.itemAdded[i].productId;
          let batch = this.itemAdded[i].batchNumber;

          if (item_id == this.selectedItem && batch == this.itemDetails.BatchNumber) {
            flag = true;
          }
        }

        if (flag == true) {
          this.$toaster.error(`Already Taken`);
          }
          else {
            if (this.editedItem.qty <= this.itemDetails.Quantity) {
        // CHECH IF CGST OR SGST
       if (this.companyStateCode === this.customer.StateCode) {
        // CGST & SGST
        this.itemAdded.push({
          item: this.itemDetails.ItemName,
          productId: JSON.parse(this.selectedItem),
          batchNumber: this.itemDetails.BatchNumber,
          hSNCode: this.itemDetails.Code,
          hSNRate: JSON.parse(this.itemDetails.HsnRate),
          qty: JSON.parse(this.editedItem.qty),
          unit: this.itemDetails.UomName,
          mrp: this.itemDetails.Mrp,
          total: JSON.parse(
            (this.itemDetails.Mrp * this.editedItem.qty).toFixed(2)
          ),
          discount: JSON.parse(this.itemDetails.Discount),
          discountAmount: JSON.parse(
            (
              (this.itemDetails.Mrp *
                this.editedItem.qty *
                this.itemDetails.Discount) /
              100
            ).toFixed(2)
          ),
          taxableAmount: JSON.parse(
            (
              this.itemDetails.Mrp * this.editedItem.qty -
              (this.itemDetails.Mrp *
                this.editedItem.qty *
                this.itemDetails.Discount) /
                100
            ).toFixed(2)
          ),
          cgst: JSON.parse(
            (
              ((this.itemDetails.Mrp * this.editedItem.qty -
                (this.itemDetails.Mrp *
                  this.editedItem.qty *
                  this.itemDetails.Discount) /
                  100) *
                (this.itemDetails.HsnRate / 100)) /
              2
            ).toFixed(2)
          ),
          cgstRate: JSON.parse(this.itemDetails.HsnRate / 2),
          sgst: JSON.parse(
            (
              ((this.itemDetails.Mrp * this.editedItem.qty -
                (this.itemDetails.Mrp *
                  this.editedItem.qty *
                  this.itemDetails.Discount) /
                  100) *
                (this.itemDetails.HsnRate / 100)) /
              2
            ).toFixed(2)
          ),
          sgstRate: JSON.parse(this.itemDetails.HsnRate / 2),
          igstRate: 0,
          igst: 0
        });
      } else {
        // IGST
        this.itemAdded.push({
          item: this.itemDetails.ItemName,
          productId: JSON.parse(this.selectedItem),
          hSNCode: this.itemDetails.Code,
          hSNRate: JSON.parse(this.itemDetails.HsnRate),
          batchNumber: this.itemDetails.BatchNumber,
          qty: JSON.parse(this.editedItem.qty),
          unit: this.itemDetails.UomName,
          mrp: this.itemDetails.Mrp,
          total: JSON.parse(
            (this.itemDetails.Mrp * this.editedItem.qty).toFixed(2)
          ),
          discount: JSON.parse(this.itemDetails.Discount),
          discountAmount: JSON.parse(
            (
              (this.itemDetails.Mrp *
                this.editedItem.qty *
                this.itemDetails.Discount) /
              100
            ).toFixed(2)
          ),
          taxableAmount: JSON.parse(
            (
              this.itemDetails.Mrp * this.editedItem.qty -
              (this.itemDetails.Mrp *
                this.editedItem.qty *
                this.itemDetails.Discount) /
                100
            ).toFixed(2)
          ),
          cgst: 0,
          cgstRate: 0,
          sgst: 0,
          sgstRate: 0,
          igstRate: JSON.parse(this.itemDetails.HsnRate),
          igst: JSON.parse(
            (
              (this.itemDetails.Mrp * this.editedItem.qty -
                (this.itemDetails.Mrp *
                  this.editedItem.qty *
                  this.itemDetails.Discount) /
                  100) *
              (this.itemDetails.HsnRate / 100)
            ).toFixed(2)
          )
        });
      }

       this.close();
      }
      else {
        this.$toaster.error(`Qty should be less then or equal Avl qty`);
        this.editedItem.qty = null;
      }
      }
      }

      console.log(this.itemAdded);
    },
    deleteItem(item) {
      const index = this.itemAdded.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.itemAdded.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.show1 = false;
        //this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.selectItem = 0;
        this.editedItem.qty = 1
      }, 300);
    },

    onSubmit() {
      /* console.log(
        {
            customerId: JSON.parse(this.customer.Id),
            invoiceDate: this.form.invoiceDate,
            taxableAmount: Math.round(this.taxableAmount * 100) / 100,
            cgst: this.cgstTotal,
            sgst: this.sgstTotal,
            igst: this.igstTotal,
            gst: this.cgstTotal + this.sgstTotal + this.igstTotal,
            totalAfterTax:
              Math.round(
                (this.taxableAmount +
                  this.cgstTotal +
                  this.sgstTotal +
                  this.igstTotal) *
                  100
              ) / 100,
            invoiceDetails: this.itemAdded
          }
      ); */
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
        .post(
          config.API + "Invoices",
          {
            customerId: JSON.parse(this.customer.Id),
            invoiceDate: this.form.invoiceDate,
            taxableAmount: Math.round(this.taxableAmount * 100) / 100,
            cgst: this.cgstTotal,
            sgst: this.sgstTotal,
            igst: this.igstTotal,
            gst: this.cgstTotal + this.sgstTotal + this.igstTotal,
            totalAfterTax:
              Math.round(
                (this.taxableAmount +
                  this.cgstTotal +
                  this.sgstTotal +
                  this.igstTotal) *
                  100
              ) / 100,
            invoiceDetails: this.itemAdded
          },
          {
            headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
          }
        )
        .then(res => {
          this.$toaster.success("Successfully added");
            //this.$router.push(`counsellingImage/${code}`);
            this.$router.go(-1);
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.btnSave = false;
        });
      } else {
        this.$toaster.error(`Required field(s) are empty!!`);
      }
    }
  },

  computed: {
    cgstTotal: function() {
      let total = [];
      Object.entries(this.itemAdded).forEach(([key, val]) => {
        total.push(val.cgst); // the value of the current key.
      });
      return total.reduce(function(total, num) {
        return total + num;
      }, 0);
    },
    sgstTotal: function() {
      let total = [];
      Object.entries(this.itemAdded).forEach(([key, val]) => {
        total.push(val.sgst); // the value of the current key.
      });
      return total.reduce(function(total, num) {
        return total + num;
      }, 0);
    },
    igstTotal: function() {
      let total = [];
      Object.entries(this.itemAdded).forEach(([key, val]) => {
        total.push(val.igst); // the value of the current key.
      });
      return total.reduce(function(total, num) {
        return total + num;
      }, 0);
    },
    taxableAmount: function() {
      let total = [];
      Object.entries(this.itemAdded).forEach(([key, val]) => {
        total.push(val.taxableAmount); // the value of the current key.
      });
      return total.reduce(function(total, num) {
        return total + num;
      }, 0);
    }
  }
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
</style>
